import React, { useReducer } from 'react';
import AccordionContext, { initialState } from '@context/AccordionContext';
import Content from './AccordionContent';
import Title from './AccordionTitle';

type State = { isOpen: boolean };
type Action = { type: 'TOGGLE' };

function reducer(state: State, action: Action) {
  switch (action.type) {
    case 'TOGGLE':
      return { isOpen: !state.isOpen };

    default:
      throw new Error();
  }
}

type AccordionProps = {
  children: JSX.Element[];
  classes?: string;
};

export default function Accordion({ children, classes }: AccordionProps) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <AccordionContext.Provider value={{ state, dispatch }}>
      <div className={classes}>{children}</div>
    </AccordionContext.Provider>
  );
}

Accordion.Title = Title;
Accordion.Content = Content;
Accordion.defaultProps = {
  classes: '',
};
